import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.string.trim.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import DarkBg from '@/components/dark-bg.vue';
import XdfInput from '@/views/home/compontents/xdf-input-active.vue';
import activeSuccessJump from '@/views/home/compontents/active-success-jump.vue';
import activeError from '@/views/home/compontents/active-error.vue';
import { activate } from '@/api/home';
import OutlineCache from '@/utils/OutlineCache.js';
var cache;
export default {
  name: 'UnbindModel',
  components: {
    DarkBg: DarkBg,
    XdfInput: XdfInput,
    activeSuccessJump: activeSuccessJump,
    activeError: activeError
  },
  props: {
    visible: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      code: '',
      colorOptions: {
        color0: 'rgba(1, 196, 143, 0.25)',
        color2: 'rgba(175, 255, 213, 1)',
        color3: 'rgba(33, 131, 118, 1)'
      },
      activeSuccessJumpDig: false,
      bindData: {},
      activeErrorDig: false,
      message: ''
    };
  },
  created: function created() {
    cache = OutlineCache.getInstance();
  },
  methods: {
    activate: function activate(val) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                val = val.trim();

                if (!(!val || val.length < 16)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", _this.$message.error('请输入16位完整激活码'));

              case 3:
                _this.code = val;

                _this.slideSuccess();

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    slideSuccess: function slideSuccess() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$activate, status, data, message;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return activate({
                  code: _this2.code
                });

              case 2:
                _yield$activate = _context2.sent;
                status = _yield$activate.status;
                data = _yield$activate.data;
                message = _yield$activate.message;

                if (!(status === 1)) {
                  _context2.next = 12;
                  break;
                }

                _this2.$store.dispatch('setUnbindSubject', false);

                _this2.bindData = data; // 关闭激活弹窗，打开跳转弹窗

                _this2.$emit('update:visible', false);

                _this2.activeSuccessJumpDig = true;
                return _context2.abrupt("return");

              case 12:
                if (status === 2) {
                  _this2.activeErrorDig = true;
                  _this2.message = message;
                }

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    slideError: function slideError(e) {
      // 错误
      this.$message.warning('请正确拼合图像');
    },
    changeDialog: function changeDialog(status) {
      this.activeSuccessJumpDig = false;

      if (status) {
        var subjectBoxIdType = {
          subject: this.bindData.subjectId,
          boxId: this.bindData.boxId,
          preciousType: 1
        };
        this.$store.dispatch('setPreciousMessage', subjectBoxIdType);
        this.$store.dispatch('setSubject', this.bindData.subjectId);
        var edu = JSON.parse(localStorage.getItem('userInfo')).edu;
        cache.switchSubject(edu, this.bindData.subjectId);
        cache.switchBox(edu, this.bindData.subjectId, this.bindData.boxId);

        if (this.$route.path === '/study') {
          window.location.reload();
        } else {
          this.$router.push('/study');
          window.location.reload();
        }
      }
    }
  }
};